import {
    MORE_SUBSTITUTES_LOADED,
    SUBSTITUES_ACTIVE_FILTER_CHANGE,
    SUBSTITUES_LOADED,
    SUBSTITUES_LOADING,
    SUBSTITUES_SEARCH_VALUE,
    SUBSTITUES_SORT
} from '../store/actionTypes';

import * as Api from 'utils/api/api';
import {Dispatch} from 'redux';
import {
    getSubstitutesActiveFilter,
    getSubstitutesForRender,
    getSubstitutesSearchValue,
    getSubstitutesSorting
} from '../store/application.reducers';
import {handleError} from 'utils/errorHandle.function';
import {ApplicationError} from 'types/applicationError';
import {
    StatusFilterValue,
    Substitute,
    SubstitutesAction,
    SubstitutesPage,
    SubstitutesSort
} from 'types/substitutes';

const FIRST_PAGE = 1;

const EMPTY_PAGE: SubstitutesPage = {page: FIRST_PAGE, rows: [], records: 0};

export function substitutesLoaded(substitutes: SubstitutesPage = EMPTY_PAGE): SubstitutesAction {
    return {
        type: SUBSTITUES_LOADED,
        data: substitutes
    };
}

export function substitutesLoading(): SubstitutesAction {
    return {
        type: SUBSTITUES_LOADING,
        data: null
    };
}

export function moreSubstitutesLoaded(substitutes: SubstitutesPage = EMPTY_PAGE): SubstitutesAction {
    return {
        type: MORE_SUBSTITUTES_LOADED,
        data: substitutes
    };
}

export function changeActiveFilter(filter: StatusFilterValue): SubstitutesAction {
    return {
        type: SUBSTITUES_ACTIVE_FILTER_CHANGE,
        data: filter
    };
}

export function changeSort(criteria: SubstitutesSort): SubstitutesAction {
    return {
        type: SUBSTITUES_SORT,
        data: criteria
    };
}

export function changeSearchValue(value: string): SubstitutesAction {
    return {
        type: SUBSTITUES_SEARCH_VALUE,
        data: value
    };
}

/**
 * One page of the list. `skipLoad` keeps the rows on screen while the request is in flight,
 * which is what every reload but the first one wants.
 */
export function getSubstitutes(page: number, activeFilter: StatusFilterValue, searchValue: string, sort: SubstitutesSort, skipLoad = false) {
    return function (dispatch: Dispatch<SubstitutesAction>) {
        if (!skipLoad)
            dispatch(substitutesLoading());

        Api.getSubstitutesSortedOnPage(page, activeFilter, searchValue, sort).then((response: SubstitutesPage) => {
                if (page > FIRST_PAGE)
                    dispatch(moreSubstitutesLoaded(response));
                else
                    dispatch(substitutesLoaded(response));
            },
            (error: ApplicationError) => {
                //a failed first page must clear the list, otherwise stale rows stay on screen
                if (page <= FIRST_PAGE)
                    dispatch(substitutesLoaded(EMPTY_PAGE));
                handleError(error);
            });
    };
}

/** Removes the substitution sitting at `index` in the loaded list, and reloads the list. */
export function deleteSubstitute(index: number) {
    return function (dispatch: Dispatch<any>, getState: () => any) {
        const state = getState();
        const searchValue = getSubstitutesSearchValue(state);
        const sort = getSubstitutesSorting(state);
        const activeFilter = getSubstitutesActiveFilter(state);
        const subs = getSubstitutesForRender(state);

        const toDelete: Substitute | undefined = subs.allSubstitutes && subs.allSubstitutes[index];
        if (toDelete) {
            //this is not really a delete, we just set the active flag to false to filter this out of the UI
            toDelete.active = false;

            Api.saveSubstitute(toDelete).then(() => {
                    dispatch(getSubstitutes(FIRST_PAGE, activeFilter, searchValue, sort, true) as any);
                },
                (error: ApplicationError) => {
                    handleError(error);
                });
        }
    };
}
